import { EmptySearchIcon } from './EmptySearchIcon';

export {
	EmptySearchIcon
};